import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const getBottleReturnItems = async (): Promise<IItemLookup[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/items/bottle-deposit-items`,
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };
  return emeraldRequest<IItemLookup[]>(emeraldRequestParams);
};
